// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/detail/detail.scss
// module id = 91
// module chunks = 0